/* Product rows (sections/product-feed.liquid, 2026-10-14).
   - Tabs: closed tabs are a <template> until first opened, so their cards are not in
     the DOM and their images are not requested. Arrow keys / Home / End move between tabs.
   - Row: arrows page through the row (hidden at each end and when the row fits),
     is-scrolled / has-more drive the edge fade, --prow-mid centres the arrows on the image
     (product card image, or the photo of an Inspired by you card).
   - Colour swatch hover on the cards, as the old product feed did. */
(function () {
  if (window.iwaProwReady) return;
  window.iwaProwReady = true;

  var rtl = document.documentElement.getAttribute('dir') === 'rtl';

  function initViewport(viewport) {
    if (viewport.iwaProwUpdate) {
      viewport.iwaProwUpdate();
      return;
    }
    var track = viewport.querySelector('[data-prow-track]');
    var prev = viewport.querySelector('[data-prow-prev]');
    var next = viewport.querySelector('[data-prow-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      var scrolled = pos > 4;
      var more = max - pos > 4;
      if (prev) prev.disabled = !scrolled;
      if (next) next.disabled = !more;
      viewport.classList.toggle('is-scrolled', scrolled);
      viewport.classList.toggle('has-more', more);
      var mask = track.querySelector('.grid-product__image-mask, .insp-gal__media');
      if (mask && mask.offsetHeight) {
        viewport.style.setProperty('--prow-mid', (mask.getBoundingClientRect().top - track.getBoundingClientRect().top + mask.offsetHeight / 2) + 'px');
      }
    }

    function page(dir) {
      var s = step();
      var n = Math.max(1, Math.floor(track.clientWidth / s));
      track.scrollBy({ left: dir * (rtl ? -1 : 1) * s * n, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    viewport.iwaProwUpdate = update;
    update();
  }

  function openPanel(panel) {
    var tpl = panel.querySelector('template[data-prow-template]');
    if (tpl) {
      panel.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
    }
    panel.querySelectorAll('[data-prow-viewport]').forEach(initViewport);
  }

  function initRow(root) {
    if (root.iwaProwInit) return;
    root.iwaProwInit = true;

    var tablist = root.querySelector('[data-prow-tablist]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-prow-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-prow-panel]'));

    panels.forEach(function (panel) {
      if (!panel.hidden) openPanel(panel);
    });

    function select(tab, focus) {
      var target = tab.getAttribute('aria-controls');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('btn--tertiary-active', on);
      });
      panels.forEach(function (p) {
        p.hidden = p.id !== target;
        if (!p.hidden) openPanel(p);
      });
      if (focus) tab.focus({ preventScroll: true });
      if (tablist && tablist.scrollWidth > tablist.clientWidth) {
        var l = tab.offsetLeft - tablist.offsetLeft;
        if (l < tablist.scrollLeft || l + tab.offsetWidth > tablist.scrollLeft + tablist.clientWidth) {
          tablist.scrollTo({ left: l - (tablist.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab, false); });
    });

    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var fwd = rtl ? 'ArrowLeft' : 'ArrowRight';
        var back = rtl ? 'ArrowRight' : 'ArrowLeft';
        var j = null;
        if (e.key === fwd) j = (i + 1) % tabs.length;
        else if (e.key === back) j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        select(tabs[j], true);
      });
    }

    // Theme editor: show the tab of the block being edited.
    root.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      for (var k = 0; k < tabs.length; k++) {
        if (tabs[k].getAttribute('data-block-id') === id) select(tabs[k], false);
      }
    });
  }

  function swatch(e, on) {
    var s = e.target.closest && e.target.closest('.iwa-prow .color-swatch--with-image');
    if (!s || (e.relatedTarget && s.contains(e.relatedTarget))) return;
    var card = s.closest('.grid-product');
    var id = s.dataset.variantId;
    var img = card && id && card.querySelector('.grid-product__color-image--' + id);
    if (!img) return;
    if (on && s.dataset.variantImage) img.style.backgroundImage = 'url(' + s.dataset.variantImage + ')';
    img.classList.toggle('is-active', on);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-iwa-prow]').forEach(initRow);
  }

  document.addEventListener('mouseover', function (e) { swatch(e, true); });
  document.addEventListener('mouseout', function (e) { swatch(e, false); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
